<style>
    nav {
        display: flex;
        position: absolute;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        margin-top: 1.5em;
        height: 20px;
    }
    img {
        height: 100%;
    }
    a {
        margin: 0;
        padding: 0;
        height: 100%;
        margin: -1em 0.5em;
    }
    span {
        font-size: 2em;
        color: white;
    }

    @media (max-width: 640px) {
        nav {
            height: 15px;
        }
        a {
            margin: -0.3em 0.5em 0;
        }
        span {
            font-size: 1.5em;
        }
    }
</style>

<nav class="navbar">
    <a id="name" href="https://spaceth.co">
        <img src="assets/spaceth.svg" alt=""/>
    </a>
    <span> + </span>
    <a id="name" href="https://www.instagram.com/d.gerrardd">
        <img src="assets/dg.png" alt=""/>
    </a>
</nav>
